import React from 'react';
import { LoanCalculator as LoanCalculatorComponent } from '../../components/loan/LoanCalculator';

export const LoanCalculator: React.FC = () => {
  return <LoanCalculatorComponent />;
};
